import React from "react";
import Card from "react-bootstrap/Card";
// import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Bami Gems </span>
            from <span className="purple"> Africa.</span>
            <br />
            <br />
            I have a Bsc In Computer Science and also a Graduate Member Of The
            Computer Professional In Africa.
            <br />
            <br />
          </p>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Bami Gems</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
